export const BubblechatColor = {
  cool: {
    0: '#E6E9F1',
    5: '#E8ECF3',
    10: '#DBE0EA',
    15: '#CAD1DF',
    20: '#B9C1D4',
    25: '#AAB1C8',
    30: '#99A0BB',
    35: '#888FAC',
    40: '#787E9E',
    45: '#676B8A',
    50: '#57596F',
    55: '#444553',
    60: '#303037',
    65: '#26262B',
    70: '#1C1C21',
    75: '#111114',
  },
  variant: {
    5: '#F7F9FF',
    10: '#F4F6FA',
    15: '#F1F1F4',
    20: '#F3F3F3',
    22: '#E8EBED',
    25: '#E7E7E7',
    30: '#D4D6DA',
    35: '#C4C6C9',
    40: '#ADB0B8',
    45: '#ACACB3',
    50: '#95959A',
    55: '#7E7E82',
    60: '#606064',
    65: '#404448',
    70: '#373D44',
  },
  aquamarine: {
    0: '#E5FCFF',
    5: '#DFF7FB',
    10: '#B0EAF4',
    20: '#7CDCEC',
    30: '#43CEE4',
    40: '#04C7E1',
    50: '#00C3DD',
    55: '#00B9D7',
    60: '#00A9C4',
    70: '#0094A9',
    80: '#008091',
    90: '#005E65',
  },
};

export const TingleColor = {
  warm: {
    0: '#F8EEEF',
    5: '#F9F3F3',
    10: '#F7E6E8',
    15: '#EFCCD3',
    20: '#E4B9C2',
    25: '#DCADB8',
    30: '#D9A2AE',
    35: '#CD8F9E',
    40: '#BD7D8E',
    45: '#95727C',
    50: '#565253',
    55: '#4A4647',
    60: '#3B3939',
    65: '#2D2B2B',
    70: '#201E1E',
    75: '#141111',
  },
  tingle_variant: {
    5: '#FAFAFA',
    10: '#F7F7F8',
    15: '#F1F1F2',
    20: '#ECECED',
    25: '#E2E2E3',
    30: '#D4D4D5',
    35: '#C6C6C6',
    40: '#B9B9BA',
    45: '#ABABAB',
    50: '#909091',
    55: '#848485',
    60: '#6A6A6A',
    65: '#474747',
    70: '#3B3B3C',
  },
  primary_pink: {
    0: '#FFF1F3',
    5: '#FFE3E6',
    10: '#FFE3E6',
    20: '#FFA1B1',
    30: '#FF95A7',
    40: '#FF708A',
    50: '#FF5776',
    55: '#EB3E64',
    60: '#E1325B',
    70: '#D72652',
    80: '#CF1044',
    90: '#B90E3E',
  },
  pink_dark: {
    5: '#F97E84',
    25: '#EE637D',
    50: '#E95772',
  },
  moody_blue: {
    50: '#748AF8',
  },
};

export const BDSColor = {
  // basic 변경 예정
  common: {
    black: '#000',
    white: '#fff',
  },
  neutral: {
    5: '#FDFDFE',
    8: '#F8F8F8',
    10: '#F5F5F6',
    15: '#EAEAEC',
    18: '#E7E7E7',
    20: '#D8D8D8',
    25: '#CCCCCC',
    30: '#BCBCBC',
    35: '#B0B0B1',
    38: '#909090',
    40: '#8A8A8A',
    45: '#696969',
    48: '#646566',
    50: '#636363',
    55: '#4B4B4B',
    60: '#424242',
    65: '#323434',
    70: '#131415', // default main font color,
    75: '#141111',
  },
  red: {
    50: '#F6375A',
    55: '#FF4444',
    80: '#800020',
  },
  pink: {
    50: '#FE008A',
    55: '#FF2F89',
  },
  purple: {
    20: '#AE85FD',
    25: '#977CD6',
    50: '#9C5DDB',
    55: '#7F62B3',
  },
  magenta: {
    40: '#EA5DD4',
    45: '#C16DAE',
    50: '#FF2181',
    55: '#D520B9',
    60: '#BE319F',
  },
  green: {
    40: '#52D0B9',
    50: '#00CF94',
    55: '#03C975',
    80: '#008080',
  },
  gold: {
    10: '#FCDB9F',
    15: '#FCA057',
    18: '#FCC500',
    20: '#F1A503',
  },
  cobalt_blue: {
    10: '#63C6FC',
    25: '#229BDC',
    50: '#138CF2',
  },
  skyblue_default: {
    5: '#DFE9F7',
    25: '#BAE3FF',
    50: '#ABDBFC',
  },
  skyblue_dark: {
    5: '#282F4E',
    25: '#2C334F',
    50: '#2B3561',
  },
  ...BubblechatColor,
  ...TingleColor,
} as const;
